import { authenticated_api } from "./base";

export const getIntegrations = async () => (await authenticated_api.get("/integrations")).data;

export const getCrmStatus = async () => (await authenticated_api.get("/integrations/hubspot/status")).data;

export const startCrmConnect = async () => (await authenticated_api.post("/integrations/hubspot/connect")).data;

export const completeCrmCallback = async ({ state, code, error }) => (
  await authenticated_api.post("/integrations/hubspot/callback", {
    state, ...(error != null ? { error } : { code }),
  })
).data;

export const disconnectCrm = async () => (await authenticated_api.post("/integrations/hubspot/disconnect")).data;

export const retryCrmExport = async (exportId) => (
  await authenticated_api.post(`/integrations/hubspot/exports/${encodeURIComponent(exportId)}/retry`)
).data;

export const getCrmExport = async (exportId) => (
  await authenticated_api.get(`/integrations/hubspot/exports/${encodeURIComponent(exportId)}`)
).data;

export const previewCrmExport = async ({ savedSearchId, companyIds }) => {
  const response = await authenticated_api.post("/integrations/hubspot/exports/preview", {
    saved_search_id: savedSearchId,
    company_ids: companyIds,
  });
  return response.data;
};

export const confirmCrmExport = async (exportId, idempotencyKey) => {
  const response = await authenticated_api.post(
    `/integrations/hubspot/exports/${encodeURIComponent(exportId)}/confirm`, undefined,
    { headers: { "Idempotency-Key": idempotencyKey } }
  );
  return response.data;
};
